import "./dropdown-with-item.component.scss";

import { memo } from "react";
import { useTranslation } from 'react-i18next';

const DropdownItem = (props) => {
  const { item, onClick } = props;
  const { t } = useTranslation();

  if (!item.icon && !item.checked) {
    return (
      <li className={`${item.isActive ? 'active' : ''}`} onClick={() => !!onClick && onClick(item)}>{t(item.title)}</li>
    );
  } else if (!!item.checked) {
    return (
      <li className={`${item.isActive ? 'active' : ''}`} onClick={() => !!onClick && onClick(item)}>{t(item.title)}</li>
    );
  } else {
    return (
      <li className={`${item.isActive ? 'active' : ''}`} onClick={() => !!onClick && onClick(item)}>
        <i className={`icon ${item.icon}`}></i>{t(item.title)}
      </li>
    );
  }
}

const DeviceDropdownItem = (props) => {
  const { item, onClick } = props;
  const { t } = useTranslation();

  return (
    <li className={`device-item ${item.isActive ? 'active' : ''}`}>
      <span className="device-name">{t(item.title)}</span>
      {item.list.map((list, index) => {
        return (
          <li key={index} className="device-item" onClick={() => !!onClick && onClick(list)}>
            {list.title}
          </li>
        );
      })}
    </li>
  );
}

const TimeDropdownItem = (props) => {
  const { item, onClick } = props;
  if (!item.icon && !item.checked) {
    return (
      <li className={`${item.isActive ? 'active' : ''}`} onClick={() => !!onClick && onClick(item)}>{item.title}</li>
    );
  } else if (!!item.checked) {
    return (
      <li className={`${item.isActive ? 'active' : ''}`} onCli
        ck={() => !!onClick && onClick(item)}>{item.title}</li>
    );
  } else {
    return (
      <li className={`${item.isActive ? 'active' : ''}`} onClick={() => !!onClick && onClick(item)}>
        <i className={`icon ${item.icon}`}></i>{item.title}
      </li>
    );
  }
}

const CheckboxDropdown = (props) => {
  const { id, extendClassName, selectedItem, itemList, disabled, onClick, isInvalid } = props;
  const { t } = useTranslation();
  const invalidClassName = !!isInvalid ? 'invalid' : '';

  return (
    <div className='dropdown'>
      <button
        className={`btn btn-dropdown dropdown-toggle ${extendClassName} ${invalidClassName}`}
        type="button"
        id={id}
        data-bs-toggle="dropdown"
        data-bs-display="static"
        disabled={disabled}
        aria-expanded="false"
      >
        <span>{t(selectedItem?.title)}</span>
      </button>
      <ul className="dropdown-menu" aria-labelledby={id}>
        {itemList?.map((item, index) => <DropdownItem item={item} key={item.title + '-' + index} onClick={onClick} />)}
      </ul>
    </div>
  );
}

const DeviceDropdown = (props) => {
  const { id, extendClassName, selectedItem, itemList, disabled, onClick, isInvalid } = props;
  const { t } = useTranslation();
  const invalidClassName = !!isInvalid ? 'invalid' : '';

  return (
    <div className='dropdown'>
      <button
        className={`btn btn-dropdown dropdown-toggle ${extendClassName} ${invalidClassName}`}
        type="button"
        id={id}
        data-bs-toggle="dropdown"
        data-bs-display="static"
        disabled={disabled}
        aria-expanded="false"
      >
        <span>{t(selectedItem?.title)}</span>
      </button>
      <ul className="dropdown-menu" aria-labelledby={id}>
        {itemList?.map((item, index) => <DeviceDropdownItem item={item} key={item.title + '-' + index} onClick={onClick} />)}
      </ul>
    </div>
  );
}

const NormalDropdown = (props) => {
  const {
    id,
    extendClassName,
    selectedItem,
    itemList,
    disabled,
    onClick,
    onKeyDown,
    dropDownMenuStyle,
    dropDownMenuRef,
    isInvalid,
    isTruncate,
    style
  } = props;
  const { t } = useTranslation();
  const invalidClassName = !!isInvalid ? 'invalid' : '';
  const truncateClassName = isTruncate ? 'text-truncate' : '';

  return (
    <div className='dropdown'>
      <button
        className={`btn btn-dropdown dropdown-toggle ${extendClassName} ${invalidClassName}`}
        type="button"
        id={id}
        data-bs-toggle="dropdown"
        data-bs-display="static"
        disabled={disabled}
        aria-expanded="false"
        style={style}
        onKeyDown={onKeyDown}
      >
        <span className={truncateClassName}>{t(selectedItem?.title)}</span>
      </button>
      <ul className="dropdown-menu" aria-labelledby={id} style={dropDownMenuStyle} ref={dropDownMenuRef || null}>
        {itemList?.map((item, index) => <DropdownItem item={item} key={item.title + '-' + index} onClick={onClick} isTruncate />)}
      </ul>
    </div>
  );
}

const TimeDropdown = (props) => {
  const { id, extendClassName, selectedItem, itemList, disabled, onClick, isInvalid } = props;
  const invalidClassName = !!isInvalid ? 'invalid' : '';

  return (
    <div className='dropdown'>
      <button
        className={`btn btn-dropdown dropdown-toggle ${extendClassName} ${invalidClassName}`}
        type="button"
        id={id}
        data-bs-toggle="dropdown"
        data-bs-display="static"
        disabled={disabled}
        aria-expanded="false"
      >
        <span>{selectedItem?.title}</span>
      </button>
      <ul className="dropdown-menu" aria-labelledby={id}>
        {itemList?.map((item, index) => <TimeDropdownItem item={item} key={item.title + '-' + index} onClick={onClick} />)}
      </ul>
    </div>
  );
}

const IconDropdown = (props) => {
  const { id, extendClassName, itemList, disabled, onClick, isInvalid } = props;
  const invalidClassName = !!isInvalid ? 'invalid' : '';

  return (
    <>
      <i
        className={`icon btn-dropdown ${extendClassName} ${invalidClassName}`}
        id={id}
        disabled={disabled}
        data-bs-toggle="dropdown"
      >
      </i>
      <ul className="dropdown-menu" aria-labelledby={id}>
        {itemList.map((item, index) => <DropdownItem item={item} key={item.title + '-' + index} onClick={onClick} />)}
      </ul>
    </>
  );
}

const DropdownWithItem = props => {
  const {
    id,
    type,
    extendClassName,
    selectedItem,
    itemList,
    disabled,
    onClick,
    onKeyDown,
    dropDownMenuStyle,
    dropDownMenuRef,
    isInvalid,
    isTruncate,
    style
  } = props;

  let dropdownType = type;
  if (!type || type === 'normal') {
    dropdownType = 'normal';
  }

  return (
    <div className='dropdown-with-item-container'>
      {dropdownType === 'normal' &&
        <NormalDropdown
          id={id}
          extendClassName={extendClassName ? extendClassName : ''}
          selectedItem={selectedItem}
          itemList={itemList}
          disabled={disabled}
          onClick={onClick}
          onKeyDown={onKeyDown}
          dropDownMenuStyle={dropDownMenuStyle}
          dropDownMenuRef={dropDownMenuRef}
          isInvalid={isInvalid}
          isTruncate={isTruncate}
          style={style}
        />}
      {dropdownType === 'device' &&
        <DeviceDropdown
          id={id}
          extendClassName={extendClassName ? extendClassName : ''}
          selectedItem={selectedItem}
          itemList={itemList}
          disabled={disabled}
          onClick={onClick}
          isInvalid={isInvalid}
        />}
      {dropdownType === 'time' &&
        <TimeDropdown
          id={id}
          extendClassName={extendClassName ? extendClassName : ''}
          selectedItem={selectedItem}
          itemList={itemList}
          disabled={disabled}
          onClick={onClick}
          isInvalid={isInvalid}
        />}
      {dropdownType === 'icon' &&
        <IconDropdown
          id={id}
          extendClassName={extendClassName ? extendClassName : ''}
          itemList={itemList}
          disabled={disabled}
          onClick={onClick}
          isInvalid={isInvalid}
        />}
      {dropdownType === 'checkbox' &&
        <CheckboxDropdown
          id={id}
          extendClassName={extendClassName ? extendClassName : ''}
          itemList={itemList}
          disabled={disabled}
          onClick={onClick}
          isInvalid={isInvalid}
        />}
    </div>
  );
};

export default memo(DropdownWithItem);
